"use client";

import { Typography } from "@material-tailwind/react";
import { useEffect, useState } from "react";
import { IoIosArrowDown } from "react-icons/io";
import { useRouter } from "next/navigation";
import {
  accreditations,
  administration,
  learningHub,
  examination,
  campusFacilities,
  campusLegacy,
  studentSupport,
  curriculum,
  departments,
  studentLife,
  innovation,
  campusBeats,
  alumni,
  pgDepartments,
} from "@/utils/pagesData/navigation";
// import {
//   College,
//   Employees,
//   Certicficate,
//   HandShake,
//   Book,
//   Examination,
//   Learning,
//   Notpad,
//   Campus,
//   StudentsLife,
//   Innovation,
// } from "@/components/Icons";
import GlimpsesModal from '../GlimpsesModal/GlimpsesModal'
import Link from 'next/link';

export default function Sidebar({
  sidebar,
  openSidebar,
  position = "right",
}: {
  sidebar: boolean;
  openSidebar: () => void;
  position?: "left" | "right";
}) {
  const [open, setOpen] = useState({
    ourCollege: false,
    program: false,
    lifeAtSahyadri: false,
  });
  const [visible, setVisible] = useState("main-menu");
  const [glimpsesModalOpen, setGlimpsesModalOpen] = useState(false);

  useEffect(() => {
    if (sidebar) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Escape" && sidebar) {
        openSidebar(false);
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [sidebar, openSidebar]);
  return (
    <div>
      {/* Backdrop overlay */}
      {sidebar && (
        <div
          onClick={() => openSidebar(false)}
          className="fixed inset-0 bg-black/40 z-20 backdrop-blur-xs transition-opacity duration-300"
        />
      )}
      <div
        className={`sidebar bg-white z-30 h-[100vh] fixed top-0 ${
          position === "left" ? "left-0" : "right-0"
        } pb-36 ${
          !sidebar
            ? position === "left"
              ? "translate-x-[-100%]"
              : "translate-x-[100%]"
            : "translate-x-0"
        } ease-in-out duration-500 pt-32 ${sidebar ? "" : ""}`}
      >
        <div className="px-8 max-w-xs">
          {position === "left" ? (
            <div className="flex flex-col pt-2">
              <div className="border-b border-gray-200 pb-3 mb-5">
                <Typography className="font-bold text-[#192f59] text-xl">Admissions</Typography>
              </div>
              <p className="text-sm text-gray-600 mb-6 leading-relaxed">
                Admissions for the upcoming academic year are now open. Apply online today.
              </p>
              <a
                href="https://apply.canaraengineering.in/"
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => openSidebar(false)}
                className="w-full flex items-center justify-center gap-2 bg-gradient-to-r from-[#2884CA] to-[#144A72] text-white font-bold py-3.5 px-5 rounded-xl shadow-md hover:shadow-lg transition-all duration-300 text-center text-base mb-4"
              >
                <span>Apply Now ↗</span>
              </a>
              <Link
                href="/admission"
                onClick={() => openSidebar(false)}
                className="w-full block text-center text-sm font-semibold text-[#2884CA] hover:underline py-2"
              >
                Admission Procedure
              </Link>
            </div>
          ) : (
            {
              "main-menu": <MainMenu open={open} setOpen={setOpen} setVisible={setVisible} sidebar={sidebar} openSidebar={openSidebar} />,
              curriculum: (
                <SubMenu
                  data={{
                    title: "Scheme & Syllabus",
                    links: curriculum,
                  }}
                  setVisible={setVisible}
                  openSidebar={openSidebar}
                />
              ),

              campusFacilities: (
                <SubMenu
                  data={{
                    title: "Explore",
                    links: campusFacilities,
                  }}
                  setVisible={setVisible}
                  openSidebar={openSidebar}
                />
              ),
              "student-support": (
                <SubMenu
                  data={{
                    title: "Student Support",
                    links: studentSupport,
                  }}
                  setVisible={setVisible}
                  openSidebar={openSidebar}
                />
              ),

              studentLife: (
                <SubMenu
                  data={{
                    title: "Student Life & Engagement",
                    links: studentLife,
                  }}
                  setVisible={setVisible}
                  openSidebar={openSidebar}
                />
              ),

              about: (
                <AboutSubMenu setVisible={setVisible} />
              ),
              academics: (
                <AcademicsSubMenu setVisible={setVisible} />
              ),
              lifeAtCanara: (
                <LifeAtCanaraSubMenu setVisible={setVisible} openSidebar={openSidebar} />
              ),
              campusLegacy: (
                <SubMenu
                  data={{
                    title: "Campus Legacy",
                    links: campusLegacy,
                  }}
                  setVisible={setVisible}
                  openSidebar={openSidebar}
                  openGlimpsesModal={setGlimpsesModalOpen}
                  backTarget="about"
                />
              ),
              administration: (
                <SubMenu
                  data={{
                    title: "Administration",
                    links: administration,
                  }}
                  setVisible={setVisible}
                  openSidebar={openSidebar}
                  backTarget="about"
                />
              ),
              accreditations: (
                <SubMenu
                  data={{
                    title: "Accreditations & Compliance",
                    links: accreditations,
                  }}
                  setVisible={setVisible}
                  openSidebar={openSidebar}
                  backTarget="about"
                />
              ),
              studentSupport: (
                <SubMenu
                  data={{
                    title: "Student Support & Welfare",
                    links: studentSupport,
                  }}
                  setVisible={setVisible}
                  openSidebar={openSidebar}
                  backTarget="about"
                />
              ),

              departments: (
                <SubMenu
                  data={{
                    title: "UG Programs",
                    links: departments,
                  }}
                  setVisible={setVisible}
                  openSidebar={openSidebar}
                  backTarget="academics"
                />
              ),

              pgDepartments: (
                <SubMenu
                  data={{
                    title: "PG Programs",
                    links: pgDepartments,
                  }}
                  setVisible={setVisible}
                  openSidebar={openSidebar}
                  backTarget="academics"
                />
              ),

              examination: (
                <SubMenu
                  data={{
                    title: "Examination & Records",
                    links: examination,
                  }}
                  setVisible={setVisible}
                  openSidebar={openSidebar}
                  backTarget="academics"
                />
              ),

              learningHub: (
                <SubMenu
                  data={{
                    title: "Learning Hub",
                    links: learningHub,
                  }}
                  setVisible={setVisible}
                  openSidebar={openSidebar}
                  backTarget="academics"
                />
              ),
              campusFacilities: (
                <SubMenu
                  data={{
                    title: "Explore",
                    links: campusFacilities,
                  }}
                  setVisible={setVisible}
                  openSidebar={openSidebar}
                  backTarget="lifeAtCanara"
                />
              ),
              innovation: (
                <SubMenu
                  data={{
                    title: "Innovation",
                    links: innovation,
                  }}
                  setVisible={setVisible}
                  openSidebar={openSidebar}
                  backTarget="lifeAtCanara"
                />
              ),
              campusBeats: (
                <SubMenu
                  data={{
                    title: "Campus Beats",
                    links: campusBeats,
                  }}
                  setVisible={setVisible}
                  openSidebar={openSidebar}
                  backTarget="lifeAtCanara"
                />
              ),
              alumni: (
                <SubMenu
                  data={{
                    title: "Alumni",
                    links: alumni,
                  }}
                  setVisible={setVisible}
                  openSidebar={openSidebar}
                  backTarget="lifeAtCanara"
                />
              ),
            }[visible]
          )}
        </div>
      </div>
      <GlimpsesModal isOpen={glimpsesModalOpen} onClose={setGlimpsesModalOpen} />
    </div>
  );
}

function SubMenu({
  setVisible,
  data,
  openSidebar,
  openGlimpsesModal,
  backTarget = "main-menu",
}: {
  setVisible: (visible: string) => void;
  data: {
    title: string;
    links: Array<{
      title: string;
      link: string;
    }>;
  };
  openSidebar: (state: boolean) => void;
  openGlimpsesModal?: (state: boolean) => void;
  backTarget?: string;
}) {
  const router = useRouter();
  return (
    <>
      <div
        onClick={() => {
          setVisible(backTarget);
        }}
        // 1. Set the main container to start from the top
        className="flex gap-2 items-start cursor-pointer"
        role="button"
        aria-expanded={true}
        aria-controls="sidebar"
        aria-label="Toggle sidebar"
      >
        {/* 2. Wrap the icon in a container that matches the exact line-height of text-lg (h-7). Add shrink-0 so it doesn't get squished by long text. */}
        <div className="h-7 flex items-center shrink-0">
          <IoIosArrowDown className="w-4 h-4 text-gray-500 rotate-90 transition-all ease-in-out duration-300 lg:hidden" />
        </div>

        <Typography className="font-medium text-gray-500 text-lg">
          {data.title}
        </Typography>
      </div>
      <div className={`space-y-2 transition-all ease-in-out duration-300 mt-2`}>
        {data.links.map((link, index) => (
          <div
            key={index}
            onClick={() => {
              if (link.link === "/glimpses-of-cec" && openGlimpsesModal) {
                openGlimpsesModal(true);
              } else {
                router.push(link.link);
              }
              setVisible("main-menu");
              openSidebar(false);
            }}
            className="flex gap-2 items-center cursor-pointer"
          >
            <Typography className=" text-gray-500 ">{link.title}</Typography>
            {/* <IoIosArrowDown className={`w-4 h-4 text-gray-500 -rotate-90 transition-all ease-in-out duration-300 lg:hidden`} /> */}
          </div>
        ))}
      </div>
    </>
  );
}

function AboutSubMenu({
  setVisible,
}: {
  setVisible: (visible: string) => void;
}) {
  const aboutItems = [
    { title: "Campus Legacy", target: "campusLegacy" },
    { title: "Leadership & Administration", target: "administration" },
    { title: "Accreditations & Compliance", target: "accreditations" },
    { title: "Student Support & Welfare", target: "studentSupport" },
  ];

  return (
    <>
      <div
        onClick={() => setVisible("main-menu")}
        className="flex gap-2 items-center cursor-pointer mb-2"
        role="button"
        aria-label="Back to main menu"
      >
        <div className="h-7 flex items-center shrink-0">
          <IoIosArrowDown className="w-4 h-4 text-[#2884CA] rotate-90 transition-all ease-in-out duration-300" />
        </div>
        <Typography className="font-semibold text-[#2884CA] text-lg">
          About
        </Typography>
      </div>
      <div className="space-y-3 transition-all ease-in-out duration-300 mt-2">
        {aboutItems.map((item, index) => (
          <div
            key={index}
            onClick={() => setVisible(item.target)}
            className="flex items-center justify-between cursor-pointer py-1"
          >
            <Typography className="text-gray-500 text-sm hover:text-[#2884CA]">
              {item.title}
            </Typography>
          </div>
        ))}
      </div>
    </>
  );
}

function AcademicsSubMenu({
  setVisible,
}: {
  setVisible: (visible: string) => void;
}) {
  const items = [
    { title: "UG Departments", target: "departments" },
    { title: "PG Programs", target: "pgDepartments" },
    { title: "Examinations & Records", target: "examination" },
    { title: "Learning Hub", target: "learningHub" },
    { title: "Scheme & Syllabus", target: "curriculum" },
  ];

  return (
    <>
      <div
        onClick={() => setVisible("main-menu")}
        className="flex gap-2 items-center cursor-pointer mb-2"
        role="button"
        aria-label="Back to main menu"
      >
        <div className="h-7 flex items-center shrink-0">
          <IoIosArrowDown className="w-4 h-4 text-[#2884CA] rotate-90 transition-all ease-in-out duration-300" />
        </div>
        <Typography className="font-semibold text-[#2884CA] text-lg">
          Academics
        </Typography>
      </div>
      <div className="space-y-3 transition-all ease-in-out duration-300 mt-2">
        {items.map((item, index) => (
          <div
            key={index}
            onClick={() => setVisible(item.target)}
            className="flex items-center justify-between cursor-pointer py-1"
          >
            <Typography className="text-gray-500 text-sm hover:text-[#2884CA]">
              {item.title}
            </Typography>
          </div>
        ))}
      </div>
    </>
  );
}

function LifeAtCanaraSubMenu({
  setVisible,
  openSidebar,
}: {
  setVisible: (visible: string) => void;
  openSidebar: (state: boolean) => void;
}) {
  const router = useRouter();
  const items = [
    { title: "Campus Facilities", target: "campusFacilities" },
    { title: "Innovation & Health", target: "innovation" },
    { title: "Alumni", link: "/alumni" },
    { title: "Campus Beats", target: "campusBeats" },
  ];

  return (
    <>
      <div
        onClick={() => setVisible("main-menu")}
        className="flex gap-2 items-center cursor-pointer mb-2"
        role="button"
        aria-label="Back to main menu"
      >
        <div className="h-7 flex items-center shrink-0">
          <IoIosArrowDown className="w-4 h-4 text-[#2884CA] rotate-90 transition-all ease-in-out duration-300" />
        </div>
        <Typography className="font-semibold text-[#2884CA] text-lg">
          Life At Canara
        </Typography>
      </div>
      <div className="space-y-3 transition-all ease-in-out duration-300 mt-2">
        {items.map((item, index) => (
          <div
            key={index}
            onClick={() => {
              if (item.link) {
                router.push(item.link);
                setVisible("main-menu");
                openSidebar(false);
              } else if (item.target) {
                setVisible(item.target);
              }
            }}
            className="flex items-center justify-between cursor-pointer py-1"
          >
            <Typography className="text-gray-500 text-sm hover:text-[#2884CA]">
              {item.title}
            </Typography>
          </div>
        ))}
      </div>
    </>
  );
}

function MainMenu({
  setVisible,
  openSidebar,
}: {
  sidebar: boolean;
  setVisible: (visible: string) => void;
  open: { ourCollege: boolean; program: boolean; lifeAtSahyadri: boolean };
  setOpen: React.Dispatch<React.SetStateAction<{ ourCollege: boolean; program: boolean; lifeAtSahyadri: boolean }>>;
  openSidebar: (state: boolean) => void;
}) {
  const router = useRouter();

  return (
    <>
      <div className="border-b-border border-b-2 py-4">
        <div
          onClick={() => {
            setVisible("about");
          }}
          className="flex items-center justify-between gap-4 text-xl cursor-pointer"
        >
          <Typography className="font-semibold text-[#2884CA]">About</Typography>
          <IoIosArrowDown className="w-5 h-5 text-[#2884CA] -rotate-90" />
        </div>
      </div>

      <div className="border-b-border border-b-2 py-4">
        <div
          onClick={() => {
            setVisible("academics");
          }}
          className="flex items-center justify-between gap-4 text-xl cursor-pointer"
        >
          <Typography className="font-semibold text-[#2884CA]">Academics</Typography>
          <IoIosArrowDown className="w-5 h-5 text-[#2884CA] -rotate-90" />
        </div>
      </div>

      <div className="border-b-border border-b-2 py-4">
        <div
          onClick={() => {
            router.push("/admission");
            openSidebar(false);
          }}
          className="flex items-center justify-between gap-4 text-xl cursor-pointer"
        >
          <Typography className="font-semibold text-[#2884CA]">Admissions</Typography>
        </div>
      </div>

      <div className="border-b-border border-b-2 py-4">
        <div
          onClick={() => {
            setVisible("lifeAtCanara");
          }}
          className="flex items-center justify-between gap-4 text-xl cursor-pointer"
        >
          <Typography className="font-semibold text-[#2884CA]">Life At Canara</Typography>
          <IoIosArrowDown className="w-5 h-5 text-[#2884CA] -rotate-90" />
        </div>
      </div>

      <div className="border-b-border border-b-2 py-4">
        <div
          onClick={() => {
            router.push("/research-development-consultancy");
            openSidebar(false);
          }}
          className="flex items-center justify-between gap-4 text-xl cursor-pointer"
        >
          <Typography className="font-semibold text-[#2884CA]">Research</Typography>
        </div>
      </div>

      <div className="border-b-border border-b-2 py-4">
        <div
          onClick={() => {
            router.push("/training-placements");
            openSidebar(false);
          }}
          className="flex items-center justify-between gap-4 text-xl cursor-pointer"
        >
          <Typography className="font-semibold text-[#2884CA]">Training & Placements</Typography>
        </div>
      </div>
    </>
  );
}